export const getSearchPagedData = async (searchUrl: string) =>
  await fetch(`/nextapi/getsearch?url=${searchUrl}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .catch((error) => {
      console.error(error);
    });
